/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, FlexContainer, Spacer, theme } from "@nordcloud/gnui";
import { PlanSortFields, SortOrder } from "~/generated/graphql";
import { TableSearchInput } from "~/components/SearchInput";
import { SortSelector } from "~/components/SortSelector";
import { useQueryState } from "~/hooks";
import { ResourceGroupPlansQuery } from "../types";

export const sortOptions = [
  {
    value: PlanSortFields.Name,
    label: "Plan Name",
  },
];

export function PlansTableHeader() {
  const { queryState, updateQueryState } =
    useQueryState<ResourceGroupPlansQuery>();

  const handleSortDirection = (sortOrder: SortOrder) => {
    updateQueryState({
      order: sortOrder,
    });
  };

  const handleSortField = (sortField: PlanSortFields) => {
    updateQueryState({
      field: sortField,
    });
  };

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <FlexContainer justifyContent="space-between">
        <SortSelector<PlanSortFields>
          options={sortOptions}
          value={queryState.field ?? PlanSortFields.Name}
          direction={queryState.order ?? SortOrder.Asc}
          onSelect={handleSortField}
          onSortChange={handleSortDirection}
        />
        <Spacer width={theme.spacing.spacing04} />
        <TableSearchInput<ResourceGroupPlansQuery>
          onSubmit={handlePhraseField}
          placeholder={`Type a Keyword (e.g. Plan Name, Plan ID, etc.)`}
        />
        <Spacer width={theme.spacing.spacing04} />
      </FlexContainer>
    </Box>
  );
}
